/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Add_Customer_Contract_Prepaid_InvalidInputs */



/**
* | output |
* | --- |
* | "Enter the amount as a number, for example 6000 or 6000.50." |
*
* @param {Partner_Add_Customer_Contract_Prepaid_InvalidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_add_customer_contract_prepaid_invalid = /** @type {((inputs?: Partner_Add_Customer_Contract_Prepaid_InvalidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Add_Customer_Contract_Prepaid_InvalidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie den Betrag als Zahl ein, zum Beispiel 6000 oder 6000,50.")
	return /** @type {LocalizedString} */ ("Enter the amount as a number, for example 6000 or 6000.50.")
});